import DiscoveryTeam from "./discoveryTeam";

export default DiscoveryTeam;
